import { Theme } from "@mui/material/styles";
import { SystemStyleObject, alpha } from "@mui/system";

const attributesItemStyle = {
  box: (): SystemStyleObject<Theme> => ({
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 0.75,
    mb: 2,
  }),
  "2cols": (): SystemStyleObject<Theme> => ({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 0.75,
    mb: 2,
  }),
  attribute: (theme: Theme): SystemStyleObject<Theme> => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    paddingTop: 1,
    paddingBottom: 1,
  }),
  upperCase: (): SystemStyleObject<Theme> => ({
    textTransform: "uppercase",
  }),
  center: (): SystemStyleObject<Theme> => ({
    textAlign: "center",
  }),
  button: (theme: Theme): SystemStyleObject<Theme> => ({
    padding: 0,
    borderRadius: 0,
    position: "relative",
    display: "inline-flex",
    color: theme.palette.text.primary,

    "&:hover, &:focus": {
      color: alpha(theme.palette.text.primary, 0.6),
      background: "none",
    },

    "&:after": {
      content: "''",
      width: "95%",
      height: "1px",
      position: "absolute",
      bottom: 0,
      left: 0,
      background: "currentColor",
      display: "block",
    },
  }),
};

export default attributesItemStyle;
